import React from "react";
import { useSingleWallet } from "../../../../hooks/useWallet";
import ErrorScreenApp from "../../../../../errorHandler/components/ErrorScreenApp/ErrorScreenApp";
import { LoaderSreen } from "../../../../../../common/components/molecule/Loader/Loader";
import Pagination from "../../../../../../common/components/organisme/Pagination/Pagination";
import ListTransactionView from "./ListTransactionView/ListTransactionView";
import { dateConverter } from "../../../../../../utils/dateConverter";
import useNavigationApp from "../../../../../../navigation/useNavigationApp";


export default function ListTransactionPresenter() {
  const { allTransactionQuery, singleWalletQuery } = useSingleWallet();
  const navigation = useNavigationApp();

  if (allTransactionQuery.isLoading || singleWalletQuery.isLoading) {
    return <div>Loading...</div>;
  }

  if (allTransactionQuery.isError || singleWalletQuery.isError) {
    return (
      <ErrorScreenApp
        axiosError={allTransactionQuery.error || singleWalletQuery.error}
      />
    );
  }

  if (!allTransactionQuery.data || !singleWalletQuery.data) {
    return <ErrorScreenApp message="No data found" />;
  }

  const content = allTransactionQuery.data?.data?.map((item) => {
    return {
      id: item.w_transaction_id,
      date: dateConverter(item.w_transaction_created_at),
      typeTransaction: item.w_transaction_type,
      description: item.w_transaction_description,
      amount: item.w_transaction_amount,
      unit: item.w_transaction_currency,
      status: item.w_transaction_status,
      onClick: () => {
        navigation.goToSingleTransaction(item.w_transaction_id, true);
      },
    };
  });

  return (
    <>
      {allTransactionQuery.isLoading ? (
        <LoaderSreen heigth={"100px"} />
      ) : (
        <>
          <ListTransactionView
            nbFound={allTransactionQuery.data?.pagination.total_count}
            content={content}
          />
          <Pagination
            centered
            currentPage={allTransactionQuery.data?.pagination.current_page}
            setCurrentPage={allTransactionQuery.setPage}
            lastPage={allTransactionQuery.data?.pagination.total_pages}
          />
        </>
      )}
    </>
  );
}
